<template>

    <m-edit1/>

    <m-single-course-1 v-bind='{...{"courseLink":null},...{}}' :style='""' class="" ></m-single-course-1>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSingleCourse1 from '@moeinmdn/miw-alpha-components/src/package/Course/Single/SingleCourse1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSingleCourse1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
